export default `\
import React from 'react';
import styled from 'styled-components';

const FoldableImage = ({
  width,
  height,
  src,
  alt,
}) => {
  const [foldAngle, setFoldAngle] =
    React.useState(0);

  // Both our top half and bottom half share
  // a few common styles
  const sharedStyles = {
    width,
    height: height / 2,
  };

  return (
    <div style={{ perspective: 500 }}>
      {/* Top half */}
      <div
        style={{
          ...sharedStyles,
          // This property's new ↓
          overflow: 'hidden',
        }}
      >
        {/* This image is new ↓ */}
        <img
          src={src}
          alt={alt}
          style={{
            width,
            height,
          }}
        />
      </div>

      {/* Bottom half */}
      <div
        style={{
          ...sharedStyles,

          // Only the bottom half gets
          // a bg-image
          backgroundSize:
            \`\${width}px \${height}px\`,
          backgroundImage:
            \`url(\${src})\`,

          // Shift our background up to
          // make it contiguous with the
          // top half:
          backgroundPosition: \`0px -100%\`,

          // Apply the folding rotation:
          transform:
            \`rotateX(\${foldAngle}deg)\`,
          transformOrigin: 'center top',

          // This optional prop can improve
          // performance, by letting the
          // browser optimize it:
          willChange: 'transform',
        }}
      />

      {/* Slider control */}
      <br />
      <label htmlFor="slider">
        Fold ratio:
      </label>
      <input
        id="slider"
        type="range"
        min={0}
        max={180}
        value={foldAngle}
        onChange={ev =>
          setFoldAngle(ev.target.value)
        }
        style={{ width }}
      />
    </div>
  );
};

export default function App() {
  return (
    <FoldableImage
      width={200}
      height={300}
      alt="A neon city at night"
      src="/img/city.jpg"
    />
  );
}
`;
